import NepaliDate from 'nepali-date-converter';

export function bsToAd(bsDateStr) {
  try {
    const bsDate = new NepaliDate(bsDateStr);
    return bsDate.toJsDate(); // returns JS Date (AD)
  } catch (e) {
    return null;
  }
}